import { render, staticRenderFns } from "./CountBox.vue?vue&type=template&id=fdaa5dea&scoped=true&"
import script from "./CountBox.vue?vue&type=script&lang=js&"
export * from "./CountBox.vue?vue&type=script&lang=js&"
import style0 from "./CountBox.vue?vue&type=style&index=0&id=fdaa5dea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdaa5dea",
  null
  
)

export default component.exports